import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
export function Testimonials() {
  return <section className="bg-mint-50 py-20 sm:py-28" aria-labelledby="testimonios-title" data-id="element-212" data-mp="3ksqer52n5c5y">
      <div className="mx-auto max-w-6xl px-6" data-id="element-213" data-mp="3fxkusbssu7ki">
        <Reveal className="max-w-2xl" data-id="element-214" data-mp="3b1clhf1a98l9">
          <h2 id="testimonios-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-215" data-mp="3b0aws7rcgnl2">
            Lo que dicen quienes ya tienen su MegaPack
          </h2>
          <p className="mt-4 text-lg text-ink-soft" data-id="element-216" data-mp="31ybhpkzw3tkr">
            Personas reales, en distintos países, con el mismo protocolo.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-217" data-mp="2s28gqigry0ze">
          {testimonials.map((item, index) => <li key={item.name} className="flex" data-id="element-218" data-mp="v9oqhp5txq53" data-mpi={index}>
              <Reveal delay={index % 4 * 0.04} className="flex h-full w-full flex-col rounded-2xl bg-white p-7 shadow-soft" data-id="element-219" data-mp="v7c6l6gih5pe">
                <div className="flex items-center gap-3" data-id="element-220" data-mp="h67xw01xbg89">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mint-100 text-sm font-semibold text-mint-800" data-id="element-221" data-mp="h4n4idrci3bz">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-222" data-mp="79v3ezyk0ycg">
                    <p className="truncate text-sm font-semibold text-ink" data-id="element-223" data-mp="c623wd86lhn0">
                      {item.name}
                    </p>
                    <p className="truncate text-xs text-ink-muted" data-id="element-224" data-mp="zwxzllfrcwzj">
                      {item.location}
                    </p>
                  </div>
                </div>
                <span className="mt-5 flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-225" data-mp="q5lbn4x2yqys">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-mint-500 text-mint-500" aria-hidden="true" data-id="element-226" data-mp="v3wkbcbn2vff" />)}
                </span>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-227" data-mp="1nm0kd25ov5y9">
                  “{item.quote}”
                </p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}